import {
  PageChangePassword,
  PageClinic,
  PageCouponFamily,
  PageCreateAdmin,
  PageCreateClient,
  PageCreateClinic,
  PageCreateCouponFamily,
  PageCreateHealthRecord,
  PageCreatePassword,
  PageCreateRecord,
  PageError404,
  PageForgotPassword,
  PageGenerateCoupon,
  PageHealthClient,
  PageHealthRecords,
  PageHome,
  PageListAdmin,
  PageListClients,
  PageListCoupon,
  PageLogin,
  PageOtp,
  PagePatient,
  PagePhoneLogin,
  PagePrivacy,
  PageProfile,
  PageRecords,
  PageRedeemCoupon,
  PageRedeemList,
  PageSignup,
  PageTerms,
  PageProduct,
  PageCreateProduct,
  PageInventory,
  PageCreateInventory,
  PageSale,
  PageSaleOrder,
  PageCdicRedeemList,
  PageListCdicClients,
  PageCreateCdicClient,
  PageListCdicCoupon,
  PageGenerateCdicCoupon,
  PageRedeemCdicCoupon,
} from "@pages";
import { IRoute } from "@interfaces";
import { AppLayout, AuthLayout, LayoutError } from "@layouts";
import { PageCreateCdicProgram } from "src/Pages/coupon/Program";
import { PageProgramList } from "src/Pages/coupon/ProgramList";
import { PageCreateCdicService } from "src/Pages/coupon/Service";

export const PATH_LOGIN = "/login";
export const PATH_SIGNUP = "/sign-up";
// admin routes
export const PATH_HOME = "/";
export const PATH_CLIENT_INFO = "/client-information";
export const PATH_CLIENT_CREATE = "/client-create";
export const PATH_COUPON_MANAGEMENT = "/coupon-management";

export const PATH_COUPON_REDEEM = "/coupon-redeem";

export const PATH_COUPON_LIST = "/coupons";
export const PATH_COUPON_FAMILY = "/coupon-family";
export const PATH_CREATE_COUPON_FAMILY = "/create-coupon-family";
export const PATH_GENERATE_COUPON = "/generate-coupon";
export const PATH_GENERATE_CDIC_COUPON = "/generate-cdic-coupon";
export const PATH_CDIC_COUPON_LIST = "/cdic-coupons";
export const PATH_CDIC_CLIENT_INFO = "/cdic-client-information";
export const PATH_CREATE_CDIC_CLIENT = "/create-cdic-client";
export const PATH_CDIC_COUPON_REDEEM = "/cdic-coupon-redeem";

export const PATH_CLINIC = "/clinic";
export const PATH_ADD_CLINIC = "/add-clinic";

export const PATH_ADMINS = "/admins";
export const PATH_ADD_ADMIN = "/add-admin";

// clinic routes
export const PATH_CHANGE_PASSWORD = "/change-password";
export const PATH_CREATE_PASSWORD = "/create-password";
export const PATH_FORGOT_PASSWORD = "/forgot-password";
export const PATH_OTP = "/otp";
export const PATH_LOGIN_BY_PHONE = "/request-by-phone";

export const PATH_REDEEM_CDIC_COUPON = "/redeem-cdic-coupon";
export const PATH_REDEEM_COUPON = "/redeem-coupon";
export const PATH_PATIENT = "/patient";
export const PATH_CDIC_PATIENT = "/cdic-patient";
export const PATH_TERMS_AND_CONDITIONS = "/terms-and-conditions";
export const PATH_PRIVACY_POLICY = "/privacy-policy";
export const PATH_MY_PROFILE = "/my-profile";
export const PATH_DEPO_RECORDS = "/depo-records";
export const PATH_CREATE_DEPO_RECORDS = "/create-records";
export const PATH_HEALTH_RECORDS = "/health-records";
export const PATH_HEALTH_RECORDS_CREATE = "/health-records/create";
export const PATH_SRHR_PATIENT = "/srhr-patient";
export const PATH_SALE_ORDER = "/sale-order";
export const PATH_CREATE_ORDER = "/create-order";
export const PATH_PRODUCT_MASTER = "/product-master";
export const PATH_PRODUCT_CREATE = "/product-create";
export const PATH_INVENTORY_MASTER = "/inventory-master";
export const PATH_INVENTORY_CREATE = "/inventory-create";
export const PATH_LOGISTIC = "/logistic";
export const PATH_REPORTS = "/reports";
export const PATH_CDIC_PROGRAM = "/cdic-program";
export const PATH_CREATE_CDIC_PROGRAM = "/create-cdic-program";
export const PATH_CREATE_SERVICE_NAME = "/create-service-name";
export const PATH_404 = "/*";

export const PATH_ABOUT = "/about";
export const PATH_BLOG = "/blog";

export const routes: Array<IRoute> = [
  //home
  { path: PATH_HOME, component: PageHome, exact: true, layout: AppLayout },
  { path: PATH_LOGIN, component: PageLogin, exact: true, layout: AuthLayout },
  { path: PATH_SIGNUP, component: PageSignup, exact: true, layout: AppLayout },
  // cdic client
  { path: PATH_CDIC_CLIENT_INFO, component: PageListCdicClients, exact: true, layout: AppLayout },
  { path: PATH_CDIC_CLIENT_INFO + "/:id", component: PageCreateCdicClient, exact: true, layout: AppLayout },
  { path: PATH_CREATE_CDIC_CLIENT, component: PageCreateCdicClient, exact: true, layout: AppLayout },
  // clients
  { path: PATH_CLIENT_INFO, component: PageListClients, exact: true, layout: AppLayout },
  { path: PATH_CLIENT_INFO + "/:id", component: PageCreateClient, exact: true, layout: AppLayout },
  { path: PATH_CLIENT_CREATE, component: PageCreateClient, exact: true, layout: AppLayout },
  // admin
  { path: PATH_ADMINS, component: PageListAdmin, exact: true, layout: AppLayout },
  { path: PATH_ADMINS + "/:id", component: PageCreateAdmin, exact: true, layout: AppLayout },
  { path: PATH_ADD_ADMIN, component: PageCreateAdmin, exact: true, layout: AppLayout },
  // clinic
  { path: PATH_CLINIC, component: PageClinic, exact: true, layout: AppLayout },
  { path: PATH_CLINIC + "/:id", component: PageCreateClinic, exact: true, layout: AppLayout },
  { path: PATH_ADD_CLINIC, component: PageCreateClinic, exact: true, layout: AppLayout },
  // srhr
  { path: PATH_DEPO_RECORDS, component: PageRecords, exact: true, layout: AppLayout },
  { path: PATH_CREATE_DEPO_RECORDS, component: PageCreateRecord, exact: true, layout: AppLayout },
  { path: PATH_DEPO_RECORDS + "/:id", component: PageCreateRecord, exact: true, layout: AppLayout },
  // healt
  { path: PATH_HEALTH_RECORDS, component: PageHealthRecords, exact: true, layout: AppLayout },
  {
    path: PATH_HEALTH_RECORDS_CREATE,
    component: PageCreateHealthRecord,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_HEALTH_RECORDS + "/:id",
    component: PageCreateHealthRecord,
    exact: true,
    layout: AppLayout,
  },
  { path: PATH_SRHR_PATIENT, component: PageHealthClient, exact: true, layout: AppLayout },
  // e-pharmacy
  { path: PATH_PRODUCT_MASTER, component: PageProduct, exact: true, layout: AppLayout },
  {
    path: PATH_PRODUCT_MASTER + "/:id",
    component: PageCreateProduct,
    exact: true,
    layout: AppLayout,
  },
  { path: PATH_PRODUCT_CREATE, component: PageCreateProduct, exact: true, layout: AppLayout },

  { path: PATH_INVENTORY_MASTER, component: PageInventory, exact: true, layout: AppLayout },
  { path: PATH_INVENTORY_CREATE, component: PageCreateInventory, exact: true, layout: AppLayout },

  { path: PATH_SALE_ORDER, component: PageSale, exact: true, layout: AppLayout },
  { path: PATH_CREATE_ORDER, component: PageSaleOrder, exact: true, layout: AppLayout },

  { path: PATH_COUPON_LIST, component: PageListCoupon, exact: true, layout: AppLayout },
  { path: PATH_CDIC_COUPON_LIST, component: PageProgramList, exact: true, layout: AppLayout },
  { path: PATH_CDIC_COUPON_LIST + "/:id", component: PageListCdicCoupon, exact: true, layout: AppLayout },
  {
    path: PATH_CREATE_CDIC_PROGRAM,
    component: PageCreateCdicProgram,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_CREATE_SERVICE_NAME,
    component: PageCreateCdicService,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_CREATE_COUPON_FAMILY,
    component: PageCreateCouponFamily,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_GENERATE_COUPON,
    component: PageGenerateCoupon,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_GENERATE_CDIC_COUPON,
    component: PageGenerateCdicCoupon,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_COUPON_FAMILY + "/:id",
    component: PageCouponFamily,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_COUPON_REDEEM,
    component: PageRedeemList,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_CDIC_COUPON_REDEEM,
    component: PageCdicRedeemList,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_REDEEM_COUPON,
    component: PageRedeemCoupon,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_REDEEM_CDIC_COUPON,
    component: PageRedeemCdicCoupon,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_PATIENT,
    component: PagePatient,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_CDIC_PATIENT,
    component: PagePatient,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_TERMS_AND_CONDITIONS,
    component: PageTerms,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_PRIVACY_POLICY,
    component: PagePrivacy,
    exact: true,
    layout: AppLayout,
  },
  {
    path: PATH_MY_PROFILE,
    component: PageProfile,
    exact: true,
    layout: AppLayout,
  },
  // clinic
  {
    path: PATH_CREATE_PASSWORD,
    component: PageCreatePassword,
    exact: true,
    layout: AuthLayout,
  },
  {
    path: PATH_CHANGE_PASSWORD,
    component: PageChangePassword,
    exact: true,
    layout: AuthLayout,
  },
  {
    path: PATH_FORGOT_PASSWORD,
    component: PageForgotPassword,
    exact: true,
    layout: AuthLayout,
  },
  {
    path: PATH_LOGIN_BY_PHONE,
    component: PagePhoneLogin,
    exact: true,
    layout: AuthLayout,
  },
  {
    path: PATH_OTP,
    component: PageOtp,
    exact: true,
    layout: AuthLayout,
  },
  {
    path: PATH_LOGIN_BY_PHONE,
    component: PagePhoneLogin,
    exact: true,
    layout: AuthLayout,
  },

  { component: PageError404, exact: false, layout: LayoutError },
];
export const adminRoutes = [
  PATH_HOME,
  PATH_CLIENT_INFO,
  PATH_CLIENT_CREATE,
  PATH_COUPON_MANAGEMENT,
  PATH_COUPON_REDEEM,
  PATH_COUPON_LIST,
  PATH_COUPON_FAMILY,
  PATH_CREATE_COUPON_FAMILY,
  PATH_GENERATE_COUPON,
  PATH_CLINIC,
  PATH_ADD_CLINIC,
  PATH_ADMINS,
  PATH_ADD_ADMIN,
  PATH_CDIC_COUPON_REDEEM,
  PATH_CDIC_CLIENT_INFO,
  PATH_CDIC_COUPON_LIST,
  PATH_GENERATE_CDIC_COUPON,
] as string[];
export const clinicRoutes = [
  PATH_REDEEM_CDIC_COUPON,
  PATH_REDEEM_COUPON,
  PATH_PATIENT,
  PATH_TERMS_AND_CONDITIONS,
  PATH_PRIVACY_POLICY,
  PATH_MY_PROFILE,
  PATH_CHANGE_PASSWORD,
  PATH_FORGOT_PASSWORD,
  PATH_LOGIN,
  PATH_HOME,
] as string[];

export const authRoutes = [
  PATH_LOGIN,
  PATH_SIGNUP,
  PATH_CHANGE_PASSWORD,
  PATH_OTP,
  PATH_LOGIN_BY_PHONE,
] as string[];

export const publicRoutes = [];
